import {
  AssetDTO,
  BaseEntityDTO,
  CriteriaBranchYearDTO,
  CriteriaGroupDTO,
  IAssetDTO,
  IBaseEntityDTO,
  ICriteriaGroupDTO,
  ITeamCriteriaSelectionDTO,
  IYearDTO,
  TeamCriteriaSelectionDTO,
  YearDTO,
} from './';

export interface ICriteriaDTO extends IBaseEntityDTO {
  name: string;
  description: string;
  number: number;
  max_count: number;
  year?: IYearDTO;
  teamCriteriaRelations: ITeamCriteriaSelectionDTO[];
  thubmnail?: IAssetDTO;
  group?: ICriteriaGroupDTO;
  video?: IAssetDTO;
  branchYearCriterias: CriteriaBranchYearDTO[];
  left(): number;
}

export class CriteriaDTO extends BaseEntityDTO implements ICriteriaDTO {
  name: string;
  description: string;
  number: number;
  max_count: number;
  year: IYearDTO;
  teamCriteriaRelations: ITeamCriteriaSelectionDTO[];
  thubmnail?: IAssetDTO;
  group?: ICriteriaGroupDTO;
  video?: IAssetDTO;
  branchYearCriterias: CriteriaBranchYearDTO[];

  constructor(data?: Partial<CriteriaDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.name = data?.name ?? '';
    this.description = data?.description ?? '';
    this.number = data?.number ?? 0;
    this.max_count = data?.max_count ?? 0;
    this.year = data?.year ? new YearDTO(data.year) : new YearDTO();
    this.teamCriteriaRelations = data?.teamCriteriaRelations
      ? data.teamCriteriaRelations.map((teamCrit) => new TeamCriteriaSelectionDTO(teamCrit))
      : [];
    this.thubmnail = data?.thubmnail ? new AssetDTO(data.thubmnail) : undefined;
    this.video = data?.video ? new AssetDTO(data.video) : undefined;
    this.group = data?.group ? new CriteriaGroupDTO(data.group) : undefined;
    this.branchYearCriterias = data?.branchYearCriterias
      ? data.branchYearCriterias.map((byc) => new CriteriaBranchYearDTO(byc))
      : [];
  }

  left() {
    let maxCount = this.max_count;
    if (this.branchYearCriterias.length == 1) {
      const branch = this.branchYearCriterias[0];
      if (branch) {
        maxCount = branch.max_count;
      }
    }
    return maxCount - this.teamCriteriaRelations.filter((value) => value.mandatory == true).length;
  }
}
